import { getSharedSiteName } from '../../utility/index.js'
import useSWR from 'swr'

const buildApiBasePath = () => {
  const siteName = getSharedSiteName(window.location.pathname)
  const isLocalhost = window.location.port
  return isLocalhost ? `/site/${siteName}` : ''
}
const buildBundleUrl = (bundleName) => {
  const apiBasePath = buildApiBasePath()
  return `${apiBasePath}/halapi/resourcebundles/${bundleName}`
}

function sessionStorageProvider() {
  // When initializing, we restore the data from `sessionStorage` into a map.
  const map = new Map(JSON.parse(sessionStorage.getItem('app-cache') || '[]'))

  // Before unloading the app, we write back all the data into `localStorage`.
  window.addEventListener('beforeunload', () => {
    const appCache = JSON.stringify(Array.from(map.entries()))
    sessionStorage.setItem('app-cache', appCache)
  })

  // We still use the map for write & read for performance.
  return map
}

const fetcher = (...args) => fetch(...args).then((res) => res.json())

function useFetch(url) {
  const { data, error, isLoading, isValidating } = useSWR(url, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  })
  return {
    data,
    isLoading,
    isError: error,
    isValidating,
  }
}

export { buildApiBasePath, buildBundleUrl, useFetch, sessionStorageProvider }
